import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * Dummy driver classes for replacement via `package.json` in browser builds.
 * Using those classes reduces the build size by one third.
 *
 * If we don't include those dummy classes (and just disable the driver import
 * with `false` in `package.json`) typeorm will throw an error on runtime and
 * during webpack builds even if those driver are not used.
 */
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var MongoDriver = /*#__PURE__*/_createClass(function MongoDriver() {
  _classCallCheck(this, MongoDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var MongoQueryRunner = /*#__PURE__*/_createClass(function MongoQueryRunner() {
  _classCallCheck(this, MongoQueryRunner);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var MongoEntityManager = /*#__PURE__*/_createClass(function MongoEntityManager() {
  _classCallCheck(this, MongoEntityManager);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var MongoRepository = /*#__PURE__*/_createClass(function MongoRepository() {
  _classCallCheck(this, MongoRepository);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var PostgresDriver = /*#__PURE__*/_createClass(function PostgresDriver() {
  _classCallCheck(this, PostgresDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var AuroraMysqlDriver = /*#__PURE__*/_createClass(function AuroraMysqlDriver() {
  _classCallCheck(this, AuroraMysqlDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var CockroachDriver = /*#__PURE__*/_createClass(function CockroachDriver() {
  _classCallCheck(this, CockroachDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var AuroraPostgresDriver = /*#__PURE__*/_createClass(function AuroraPostgresDriver() {
  _classCallCheck(this, AuroraPostgresDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var SqlServerDriver = /*#__PURE__*/_createClass(function SqlServerDriver() {
  _classCallCheck(this, SqlServerDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var SapDriver = /*#__PURE__*/_createClass(function SapDriver() {
  _classCallCheck(this, SapDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var MysqlDriver = /*#__PURE__*/_createClass(function MysqlDriver() {
  _classCallCheck(this, MysqlDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var OracleDriver = /*#__PURE__*/_createClass(function OracleDriver() {
  _classCallCheck(this, OracleDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var SqliteDriver = /*#__PURE__*/_createClass(function SqliteDriver() {
  _classCallCheck(this, SqliteDriver);
});
/**
 * DO NOT IMPORT THIS CLASS -
 * This is a dummy class for replacement via `package.json` in browser builds
 */
export var BetterSqlite3Driver = /*#__PURE__*/_createClass(function BetterSqlite3Driver() {
  _classCallCheck(this, BetterSqlite3Driver);
});